// extracted by mini-css-extract-plugin
export default {"ContributorFooterContainer":"ContributorFooter-module__ContributorFooterContainer__bpraE27"};